import {isModalShown} from '@chekin/shared';
import {useGuestGroup} from 'hooks/useGuestGroup';
import {useGetReservationType} from 'hooks/useGetReservationType';
import {useReservation} from 'context/reservation/useReservation';
import {useSummary} from 'context/summary';
import {SHOWED_GUEST_GROUP_MODAL} from 'utils/constants';

function useComputedOnboardingDetails() {
  const {guestGroup, isLoading: isLoadingGuestGroup} = useGuestGroup();
  const {hasReservationGroup} = useGetReservationType();
  const {data: summary} = useSummary();
  const {allowEditingGuestNumber, reservationId} = useReservation();
  const knownNumberOfGuests = guestGroup?.known_number_of_guests ?? 0;
  const addedNumberOfGuests = guestGroup?.added_number_of_guests ?? 0;
  const hasTaxes = summary?.taxes?.active;
  const isNumberOfGuestsStepShown = isModalShown(SHOWED_GUEST_GROUP_MODAL, reservationId);
  const shouldHideNumberOfGuests = !allowEditingGuestNumber && !hasTaxes;

  return {
    shouldAskReservationGroup: hasReservationGroup,
    shouldAskNumberOfGuests: !shouldHideNumberOfGuests && !isNumberOfGuestsStepShown,
    areGuestCreated: Boolean(guestGroup?.members?.length),
    remainingAllowedGuest: knownNumberOfGuests - addedNumberOfGuests,
    isLoadingDetails: isLoadingGuestGroup,
  };
}

export {useComputedOnboardingDetails};
